// ** React Imports
import { useEffect } from 'react'

// ** Next Imports
import { useLocation, useNavigate } from 'react-router-dom'

// ** Hooks Import
import { useAuth } from 'src/hooks/useAuth'

// ** Config
import authConfig from 'src/configs/auth'

const GuestGuard = props => {
  const { children, fallback } = props
  const auth = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const allowAuthenticatedAccess =
    location.pathname === '/register' &&
    (location.state?.editMode === true || location.state?.fromSubscriptionSwitch === true)

  useEffect(() => {
    if (window.localStorage.getItem(authConfig.storageUserDataKeyName) && !allowAuthenticatedAccess) {
      navigate('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowAuthenticatedAccess])
  if (auth.loading) {
    return fallback
  }

  return <>{children}</>
}

export default GuestGuard
